// Place your application-specific JavaScript functions and classes here
// This file is automatically included by javascript_include_tag :defaults
if (typeof DROPZONE_TIMEOUT == 'undefined') {
  // const cannot be used inside blocks
  window.DROPZONE_TIMEOUT = 120000;
}
var menuTimer, subMenuTimer;
var error_handled_locally = false;

window.errorAlert =
  window.errorAlert ||
  function (message, callback, optionalTitle) {
    var alertTitle = optionalTitle || 'Error';
    setTimeout(function () {
      var alertPromise = swal(alertTitle, message);
      if (
        callback !== null &&
        callback !== undefined &&
        alertPromise != null &&
        typeof alertPromise.then === 'function'
      ) {
        alertPromise.then(function () {
          callback();
        });
      }
    }, 300);
  };

//Override the default confirm dialog by rails
$.rails.allowAction = function (link) {
  if (link.data('confirm') == undefined) {
    return true;
  }
  confirm(link.data('confirm'), function (confirmed) {
    if (confirmed) {
      link.data('confirm', null);
      link.trigger('click.rails');
    }
  });
  return false;
};

//exit confirm boxes with 'esc' key
$(document).keyup('#custom_dialog_box', function (e) {
  if (e.keyCode == 27) {
    $(document)
      .find('#custom_dialog_box')
      .first()
      .find('#confirm_button_cancel')
      .click();
  }
});

$(document).ajaxStop(function (e) {
  if (
    typeof render_start_time !== 'undefined' &&
    typeof first_page_load !== 'undefined'
  ) {
    if ($.active == 0 && first_page_load) {
      window.send_render_report();
      first_page_load = false;
    }
  }
});

window.onbeforeunload = function (e) {
  if (typeof window.start_lightbox_spinner == 'function') {
    window.start_lightbox_spinner();
  }
};

$(document).on('change', "[name = 'p2_bill[doc_no]']", function () {
  if (typeof vendor_bill_doc_numbers == 'undefined') var bill_doc_numbers = [];
  else var bill_doc_numbers = vendor_bill_doc_numbers;

  if (
    typeof vendor_bill_doc_numbers_by_entity !== 'undefined' &&
    typeof vendor_bill_doc_numbers == 'undefined'
  ) {
    if ($('#maintenance_request_vendor_ids_').length > 0)
      var entity_id = $('#maintenance_request_vendor_ids_').val();
    else var entity_id = $(this).parents('form').find('#entity_id').val();
    bill_doc_numbers = vendor_bill_doc_numbers_by_entity[entity_id];
  }
  if (bill_doc_numbers.length > 0) {
    var prev_doc_no = $(this).attr('original_doc_no');
    var new_val = $(this).val();
    if (
      prev_doc_no != new_val &&
      bill_doc_numbers.indexOf(new_val) != -1 &&
      new_val != ''
    ) {
      errorAlert('"' + new_val + '" doc number already exists for this vendor');
    }
  }
});

window.send_render_report = function () {
  var now = Date.now() / 1000;

  if (now - render_start_time >= 60) {
    $.ajax({
      url: '/send_slow_render_report',
      data: {
        page: window.location.pathname,
        seconds: now - render_start_time,
      },
    });
  }
};

window.titleize = function (str_input) {
  // this function removes underscores (or spaces), separates numbers from letters and capitalizes the first letter of each word
  var str_array = str_input.replace(new RegExp(/\d+/g), '_$&_').split(/[\s_]+/);
  str_array = str_array.map(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  });
  var index = str_array.indexOf('');
  while (index != -1) {
    str_array.splice(index, 1);
    index = str_array.indexOf('');
  }
  return str_array.join(' ');
};

window.push_logged_in_event = function (data, callback, callback_arg) {
  dataLayer.push({
    event: 'loggedIn',
    loginusertype: data.loginusertype,
    emailaddress: data.emailaddress,
    firstname: data.firstname,
    lastname: data.lastname,
    company: data.company,
    numberofunits: data.numberofunits,
  });

  // Delay the callback by 3 seconds due to asynchronous third-party API calls
  if (typeof callback == 'function') {
    var delayed_callback;
    if (typeof callback_arg != 'undefined') {
      delayed_callback = function () {
        callback(callback_arg);
      };
    } else {
      delayed_callback = function () {
        callback();
      };
    }
    setTimeout(delayed_callback, 3000);
  }
};

window.add_error_bubble = function (field, message) {
  try {
    if ($('.popup_window').length > 0) {
      field = '.popup_window ' + field;
    }
    if (field.indexOf('_name') != -1) {
      arr = field.split('_');
      arr[arr.length - 1] = 'firstname]';
      if ($(arr.join('_')).length > 0) {
        field = arr.join('_');
      }
    }
    if ($(field).filter(':visible').size() > 0) {
      field = $(field).filter(':visible').first();
    }
    d = new Date().getTime();
    error_tag =
      '<div class="error_wrapper" id="error_' +
      d +
      '"><div class="error_bubble">' +
      '<div class="bg_tile"><span>' +
      message +
      '</span></div></div></div>';
    visi = $(field)
      .closest('.info_edit, .text_enclosure, .textarea_enclosure')
      .is(':visible');
    offset = visi
      ? $(field)
          .closest('.info_edit, .text_enclosure, .textarea_enclosure')
          .offset()
      : $(field).closest('form, .popup_window, body, select').offset();
    new_tag = $(error_tag)
      .appendTo('body')
      .css({ top: offset.top, left: offset.left });
    if (offset.left < $('.error_bubble', new_tag).outerWidth() + 90) {
      new_tag.css('left', $('.error_bubble', new_tag).outerWidth() + 90);
    }
    if (offset.top < min_height) {
      top_i++;
      new_tag.css('visibility', 'hidden');
    } else if (offset.top > max_height) {
      bot_i++;
      new_tag.css('visibility', 'hidden');
    }
  } catch (e) {}
};

window.add_further_error_bubble = function () {
  $('[id^=error_bot]').each(function () {
    $(this).remove();
  });
  $('[id^=error_top]').each(function () {
    $(this).remove();
  });
  d = new Date().getTime();
  if (top_i > 0) {
    top_val =
      ($(window).height() -
        $('#' + window.current_lightbox.id + '-div .buffer').height()) /
      2;
    error_tag_top =
      '<div class="error_wrapper" id="error_top_' +
      d +
      '"><div class="error_bubble">' +
      '<div class="bg_tile"><span>' +
      'There ' +
      (top_i == 1 ? 'is' : 'are') +
      ' still ' +
      top_i +
      ' error' +
      (top_i == 1 ? '' : 's') +
      ' above </span></div></div></div>';
    new_tag_top = $(error_tag_top)
      .appendTo('body')
      .css({ top: top_val, left: $(window).width() / 2 });
  }

  if (bot_i > 0) {
    bot_val =
      ($(window).height() +
        $('#' + window.current_lightbox.id + '-div .buffer').height()) /
      2;
    error_tag_bot =
      '<div class="error_wrapper" id="error_bot_' +
      d +
      '"><div class="error_bubble">' +
      '<div class="bg_tile"><span>' +
      'There ' +
      (bot_i == 1 ? 'is' : 'are') +
      ' still ' +
      bot_i +
      ' error' +
      (bot_i == 1 ? '' : 's') +
      ' below </span></div></div></div>';
    new_tag_bot = $(error_tag_bot)
      .appendTo('body')
      .css({ top: bot_val + 50, left: $(window).width() / 2 });
  }
};

window.create_entity_name_tab = function (id, name, icon, former_tenant) {
  /**append html 'entity name' block to a given element/id**/
  var formerLabel = '';
  if (typeof former_tenant !== 'undefined' && former_tenant)
    formerLabel = "<span class='former_label'>Former</span>";
  $(id).append(
    "<div class='tile'><span class='" +
      icon +
      "'><span class='eye_icon'>&nbsp;&nbsp;</span></span><span class='name'>" +
      name +
      '</span>' +
      formerLabel +
      '</div>'
  );
};

window.move_error_bubbles = function (id) {
  $('.error_wrapper')
    .not('[id*=bot]')
    .not('[id*=top]')
    .children('.error_bubble')
    .each(function () {
      offset = $(this).offset();
      $(this).offset({ top: offset.top + (offset_start - $(id).scrollTop()) });
      offset = $(this).offset();

      if ($(this).css('visibility') != 'hidden') {
        if (offset.top < min_height) {
          top_i++;
          $(this).css('visibility', 'hidden');
        } else if (offset.top > max_height) {
          bot_i++;
          $(this).css('visibility', 'hidden');
        }
      } else if (offset.top < max_height && offset.top > min_height) {
        if (offset.top > (min_height + max_height) / 2) {
          bot_i--;
        }
        if (offset.top < (min_height + max_height) / 2) {
          top_i--;
        }
        $(this).css('visibility', 'visible');
      }
      window.add_further_error_bubble();
    });
  offset_start = $(id).scrollTop();
};

window.remove_error_bubble = function () {
  $('.error_wrapper').fadeOut('slow', function () {
    $(this).remove();
  });
};

window.format_currency_amount = function (num) {
  return isNaN(num) || num === '' || num === null
    ? ''
    : parseFloat(num).toFixed(2).toString();
};

window.lightbox_reinit_scroll_panes = function (container) {
  $('.jspContainer', container).each(function () {
    $(this).parent().data('jsp').reinitialise();
  });
};

//Focuses scroll on chosen menu
window.chosen_menu_scrolling = function () {
  $('.chosen-results').on({
    mousewheel: function (e) {
      if (e.target.id == 'el') return;
      e.preventDefault();
      e.stopPropagation();
    },
  });
};

//updates attachment count on a transaction
window.update_focused_att_count = function (method) {
  var val = $('.focused_att_count').find('.count').data('count');
  if (method == 'create') new_val = val + 1;
  else new_val = val - 1;

  $('.focused_att_count').find('.count').data('count', new_val);
  $('.focused_att_count').find('.count').html(new_val);
};

window.reinit_scroll_panes = function (container) {
  $('.scroll_pane', container)
    .add($(container).filter('.scroll_pane'))
    .each(function () {
      var api = $(this).data('jsp');
      if (typeof api != 'undefined') {
        api.reinitialise();
      } else {
        var pane = $(this).find('.jspPane');
        if (pane.length != 0) {
          $(this).html(pane.html());
        }
        $(this).jScrollPane({
          verticalGutter: 0,
        });
      }
    });
};

window.resizeWholePanel = function () {
  var current_height = $(window).height();
  var min_height = parseInt($('.wholepage').css('min-height'), 10);
  var height_offset = Math.max(current_height - min_height, 0);

  var $div = $('.whole_panel');
  $div.height(parseInt($div.css('min-height'), 10) + height_offset);

  window.reinit_scroll_panes(document);
};

// interval to check session, in milliseconds; initialized value is fallback
var checkSessionTimeoutInterval = 10000;

window.initCheckNotifications = function () {
  $.ajax({
    url: '/check_notifications_interval',
    type: 'GET',
    dataType: 'JSON',
    success: function (data) {
      checkSessionTimeoutInterval = parseInt(data.interval) * 1000;
      window.queueCheckNotifications();
    },
    error: function (req, stat, err) {
      checkSessionTimeoutInterval = 60000;
      window.queueCheckNotifications();
    },
  });
};

window.checkNotifications = function () {
  $.ajax({
    url: '/check_notifications',
    type: 'GET',
    dataType: 'JSON',
    success: window.parseNotificationsData,
    error: function (xhr, status, err) {
      if (status.status == 503) {
        error_handled_locally = true;
      }
    },
  });
};

window.queueCheckNotifications = function () {
  if (checkSessionTimeoutInterval > 0) {
    setTimeout(window.checkNotifications, checkSessionTimeoutInterval);
  }
};

window.parseNotificationsData = function (data) {
  if (parseInt(data.logged_in)) {
    var current_notification_count = $('.authlinks_notification_row').length;
    if (
      $('#authlinks_notifications_list').length > 0 &&
      (current_notification_count != data.notification_count ||
        data.notification_force_refresh)
    ) {
      window.refreshNotifications();
    }
    if (
      $.inArray('maintenance', data.current_page_info) != -1 &&
      data.recently_edited_mrs.length > 0
    ) {
      window.refreshMaintenancePageDetails(data.recently_edited_mrs);
    }
    if (
      $.inArray('mobile_maintenance', data.current_page_info) != -1 &&
      $.inArray('index', data.current_page_info) != -1
    ) {
      var request_count = $('.ticket_row').length;
      if (
        request_count != data.request_count ||
        data.mobile_maintenance_force_refresh
      ) {
        window.refreshMobileMaintenanceIndex();
      }
    }
    window.queueCheckNotifications();
  }
};

window.handleAllMemorizedSchedules = function () {
  $.ajax({
    url: '/memorized_schedules',
    type: 'GET',
  });
};

window.handleNewMemorizedSchedule = function (elem) {
  var maintenanceRequestID = $(elem).data('maintenance-request-id');
  $.ajax({
    url: '/memorized_schedules/new',
    type: 'GET',
    data: {
      template_record_id: maintenanceRequestID,
    },
  });
};

window.handleEditMemorizedSchedule = function (elem) {
  var schedID = $(elem).data('maintenance-schedule-id');
  $.ajax({
    url: '/memorized_schedules/' + schedID + '/edit',
    type: 'GET',
  });
};

window.compose_email = function (elem, multi) {
  multi = multi || false;
  var email_type = $(elem).data('type');
  var obj_id = $(elem).data('id');
  $.ajax({
    url: '/emails/email_lightbox',
    dataType: 'script',
    data: {
      type: email_type,
      id: obj_id,
      window_width: $(window).width(),
      window_height: $(window).height(),
      multi: multi,
    },
  });
};

window.print_confirm = function (elem) {
  var url = $(elem).data('path');
  if (!url && $(elem).data('backup-path')) {
    url = $(elem).data('backup-path');
  }
  if (url) {
    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'JSON',
      success: function (data) {
        if (data.url) {
          window.open(data.url, '_blank');
        } else if (data.error) {
          errorAlert(data.error);
        }
      },
    });
  } else {
    errorAlert(
      'A print template could not be found. Please go to your settings and set the default template.'
    );
  }
};

window.multi_print_confirm = function (elem) {
  var url = $(elem).data('path');
  if (url) {
    $.ajax({
      url: url,
      dataType: 'script',
    });
  } else {
    errorAlert(
      'The check template being used is not eligible for multi print. Please contact Property Matrix support for assistance.'
    );
  }
};

window.handleFeatureRestrictionModalResponse =
  window.handleFeatureRestrictionModalResponse ||
  function (response) {
    if (!response || !response.featureRestrictionModal) return false;

    window.dispatchEvent(
      new CustomEvent('propertymatrix:feature-restriction', {
        detail: response.featureRestrictionModal,
      })
    );

    return true;
  };

window.refreshNotifications = function () {
  $.ajax({
    url: '/refresh_notifications',
    type: 'GET',
  });
};

window.refreshMobileMaintenanceIndex = function () {
  $.ajax({
    url: '/refresh_mobile_maintenance_index',
    type: 'GET',
  });
};

window.resetSessionTimeout = function () {
  $.ajax({
    url: '/reset_timeout',
    type: 'GET',
    success: window.queueCheckNotifications,
  });
};

window.refreshMaintenancePageDetails = function (recently_edited_mrs) {
  var mrIds = [];
  if (Array.isArray(recently_edited_mrs)) {
    mrIds = recently_edited_mrs.map(function (e) {
      return e['id'];
    });
  }
  $.ajax({
    url: '/refresh_maintenance_requests',
    type: 'POST',
    data: { maintenance_request_ids: mrIds },
  });
};

//returns false if an entity could not be selected, and true otherwise
window.select_entity_and_tab = function (entity_selector, entity, tab) {
  $('#' + tab).click();
  if (entity == null || entity == '') return false;
  $(entity_selector + entity).click();
  return true;
};

window.start_lightbox_spinner = function () {
  start_loading_spinner($('body > .loading_spinner').last());
};

window.stop_lightbox_spinner = function () {
  window.stop_loading_spinner($('body > .loading_spinner').last());
};

window.ripple_click = function (r, e) {
  var ink, d, x, y;
  ripple = r.find('.ripple');
  if (ripple.hasClass('animate')) ripple.removeClass('animate');
  if (!ripple.height() && !ripple.width()) {
    d = Math.max(r.outerWidth(), r.outerHeight());
    ripple.css({ height: d, width: d });
  }
  x = e.pageX - r.offset().left - ripple.width() / 2;
  y = e.pageY - r.offset().top - ripple.height() / 2;
  ripple.css({ top: y + 'px', left: x + 'px' }).addClass('animate');
  setTimeout(function () {
    ripple.removeClass('animate');
  }, 1000);
};

window.setCountryStateDatumBlocks = function (
  dom,
  stateBlock,
  countryID,
  options
) {
  var countries = Object.keys(options);
  $(dom)
    .find(countryID)
    .on('change', function () {
      matchCountry: for (i = 0; i < countries.length; i++) {
        if ($(this).val() == countries[i]) {
          var currentCountry = countries[i];
          break matchCountry;
        }
      }
      if (currentCountry == null || stateBlock == null) return;

      var $state = $(stateBlock.textField);
      var state_keys = Object.keys(options[currentCountry]);
      var states = state_keys.map(function (v) {
        return options[currentCountry][v];
      });

      stateBlock.modifiedSource = states.map(function (state) {
        return { value: state, text: state };
      });
      stateBlock.reinit();

      //updates address titles
      if (currentCountry == 'Canada') {
        $state.parent().find('.title').html('Province');
        $(dom).find('#zipcode').parent().find('.title').html('Postal Code');
      } else {
        $state.parent().find('.title').html('State');
        $(dom).find('#zipcode').parent().find('.title').html('Zipcode');
      }
    });
};

window.setDefaultState = function (state) {
  $('.default_state').val(state);
};

window.email_compose_ckeditor = function (gccf_id, entity_type) {
  if ($("[name = 'email[body]']").length > 0) {
    var email_body = $('#' + gccf_id + '_body')[0];

    var entity_datafields = {};
    if (entity_type != '')
      entity_datafields = {
        name: 'entity_datafield',
        items: ['entity_datafield'],
      };

    CKEDITOR.replace(email_body, {
      fullPage: true,
      height: 390,
      width: 900,
      extraPlugins: 'entity_datafield',
      allowedContent: true,
      toolbar: [
        {
          name: 'document',
          groups: ['mode', 'document', 'doctools'],
          items: [
            'Source',
            '-',
            'Save',
            'NewPage',
            'Preview',
            'Print',
            '-',
            'Templates',
          ],
        },
        '/',
        {
          name: 'basicstyles',
          groups: ['basicstyles', 'cleanup'],
          items: [
            'Bold',
            'Italic',
            'Underline',
            'Strike',
            'Subscript',
            'Superscript',
            '-',
            'RemoveFormat',
          ],
        },
        {
          name: 'paragraph',
          groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
          items: [
            'NumberedList',
            'BulletedList',
            '-',
            'Outdent',
            'Indent',
            '-',
            'Blockquote',
            'CreateDiv',
            '-',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            '-',
            'BidiLtr',
            'BidiRtl',
            'Language',
          ],
        },
        '/',
        {
          name: 'styles',
          items: ['Styles', 'Format', 'Font', 'FontSize', 'lineheight'],
        },
        { name: 'colors', items: ['TextColor', 'BGColor'] },
        { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
        { name: 'others', items: ['-'] },
        { name: 'about', items: ['About'] },
        entity_datafields,
      ],
    });

    CKEDITOR.on('instanceReady', function () {
      window.reinit_scroll_panes('#emails_tab_scrolling');
    });
    $('#' + gccf_id).bind('ajax:before', function () {
      for (instance in CKEDITOR.instances) {
        CKEDITOR.instances[instance].updateElement();
      }
    });
  }
};

window.adjust_email_compose_ckeditor = function (gccf_id) {
  if (gccf_id == '') {
    gccf_id = 'email_template';
    var compose_form = '.global_email_fields';
    var CKEheight = $('.email_body_container').height();
  } else {
    var compose_form = '#' + gccf_id;
    var CKEheight = $('.email_body_container', '#' + gccf_id).height();
  }
  var inlineComposeHost = $(compose_form).closest('#compose-email');
  if ($(compose_form).parents('.popup_window').length > 0) {
    var FORM_HEIGHT = $(compose_form).parents('.popup_window').height() - 160;
    var CKEwidth = $(compose_form).parents('.popup_window').width() - 100;
    var att_btn_margin = $(compose_form).parents('.popup_window').width() - 220;
    $(compose_form)
      .parents('.popup_window')
      .find('.add_attachment_btn')
      .css('margin-left', att_btn_margin + 'px');
  } else if (inlineComposeHost.length > 0) {
    var inlineHostTop = inlineComposeHost[0].getBoundingClientRect().top;
    var inlineAvailableHeight = $(window).height() - inlineHostTop - 24;
    var FORM_HEIGHT = Math.max(Math.min(inlineAvailableHeight, 500), 240);
    var CKEwidth = inlineComposeHost.innerWidth() || 900;
  } else {
    var FORM_HEIGHT = 500;
    var CKEwidth = 900;
  }
  if ($(compose_form).height() != FORM_HEIGHT && $(compose_form).height() > 0) {
    var extra_space = FORM_HEIGHT - $(compose_form).height();
    CKEheight += extra_space;
    CKEheight = Math.min(CKEheight, FORM_HEIGHT);
    if (CKEDITOR.instances[gccf_id + '_body'] != undefined) {
      CKEDITOR.instances[gccf_id + '_body'].resize(
        CKEwidth,
        Math.max(CKEheight, 240)
      );

      if ($(compose_form).parents('.wrapper').length > 0) {
        if (CKEheight < 240)
          $(compose_form).parents('.wrapper').css('overflow', 'auto');
        else $(compose_form).parents('.wrapper').css('overflow', 'hidden');
      }
    }
  }
};

window.open_item_manager = function (list) {
  if ($(list).val() != '' && $(list).val() < 1) {
    $.ajax({ url: '/items', type: 'get', dataType: 'script' });
  }
  account_cell = $(list)
    .closest('.line_item_row')
    .find('.line_item_account.info_edit');
  selected_option = $(list).children('option:selected');
  $(account_cell).html($(selected_option).attr('name'));
};

/* Makes a browser html post request that is not asynchronous */
window.html_post = function (path, params, method) {
  method = method || 'post';

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      var hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
};

window.applyAutocompleteOff = function (root) {
  var selectors = [
    '.pm-datepicker-field',
    '.datepicker',
    '.datetimepicker',
    '.pm-datetimepicker-field',
    'input[type="date"]',
    '.pm-format-money',
    '.currency_field',
  ].join(',');
  var $root = root ? $(root) : $(document);
  var $targets = $root.find(selectors).add($root.filter(selectors));

  $targets.each(function () {
    var $el = $(this);
    if ($el.is('input, textarea')) {
      if ($el.data('pmAutocompleteOff')) return;
      $el.attr('autocomplete', 'off');
      $el.data('pmAutocompleteOff', true);
      return;
    }

    $el.find('input, textarea').each(function () {
      var $input = $(this);
      if ($input.data('pmAutocompleteOff')) return;
      $input.attr('autocomplete', 'off');
      $input.data('pmAutocompleteOff', true);
    });
  });
};

window.initAutocompleteObserver = function () {
  if (window._pmAutocompleteObserver) return;
  if (typeof MutationObserver === 'undefined') return;

  window._pmAutocompleteObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        window.applyAutocompleteOff(node);
      });
    });
  });

  window._pmAutocompleteObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

window.applicationInit = function () {
  try {
    window.pmatrix.ui.BigSpinner.start();
  } catch (e) {}

  window.applyAutocompleteOff();
  window.initAutocompleteObserver();

  $('#settings_img')
    .closest('.settings_bg')
    .hover(
      function () {
        $(this).addClass('selected');
      },
      function () {
        $(this).removeClass('selected');
      }
    );

  $(document).click(window.remove_error_bubble);

  // Datepicker default date format
  $.datepicker.setDefaults({
    dateFormat: window.pmatrix.ui.dateFormat,
  });

  // opens item manager lightbox when "Manage..." is selected
  $(document).on(
    'change',
    '#transactions_tab_content select.line_item_select[id$=_item_id]',
    function () {
      window.open_item_manager(this);
    }
  );
  $(document).on(
    'change',
    '#account_tile_div select.line_item_select[id$=_item_id]',
    function () {
      window.open_item_manager(this);
    }
  );

  // used to reopen item manager lightbox when "Manage..." is reselected
  $(document).on('click', '#items_chosen_menu li', function (e) {
    $(this).closest('.chosen-container').prev('select').trigger('change');
  });
  $(document).on(
    'click',
    '#account_tile_div [id$=_item_id_chosen] li',
    function (e) {
      $(this).closest('.chosen-container').prev('select').trigger('change');
    }
  );

  $(document).on(
    'change',
    'select.line_item_select[id$=_company_id]',
    function () {
      var $form = $(this).closest('form');
      if (
        $form.attr('id').indexOf('bill') > -1 ||
        ($form.data('transaction-class') &&
          $form.data('transaction-class').indexOf('bill') > -1)
      ) {
        // Allow multiple companies in line items for bills
      } else {
        var company_selected = $(this).val();
        var company_name = $('option:selected', this).text();
        $form.find("select[id*='company_id']").each(function () {
          $(this)
            .val(company_selected)
            .parent()
            .find('.chosen-single')
            .find('span')
            .html(company_name);
        });
      }
    }
  );

  $(document).on('change pop_text', '.drop_down select', function () {
    $(this).siblings('.bg_tile').html($(this).find('option:selected').html());
  });
  $('.drop_down select').change();

  $(document).on('change format', '.currency_field', function () {
    myVal = parseFloat($(this).val());
    if (isNaN(myVal)) myVal = 0;
    $(this).val(myVal.toFixed(2));
  });

  $(document)
    .on('click', '.datepicker', function () {
      $(this)
        .datepicker({
          showOn: 'focus',
          dateFormat: window.pmatrix.ui.dateFormat,
        })
        .focus();
    })
    .on('format', '.datepicker', function () {
      var d = $(this).datetimepicker('getDate');
      if (typeof d == 'undefined') d = new Date();
      $(this).val($.datepicker.formatDate(window.pmatrix.ui.dateFormat, d));
    })
    .on('click', '.timepicker', function () {
      $(this).timepicker({ showOn: 'focus', ampm: true }).focus();
    })
    .on('format', '.timepicker', function () {
      var d = $(this).datetimepicker('getDate');
      if (typeof d == 'undefined') d = new Date();
      $(this).val(
        $.datepicker.formatTime(
          'hh:mm tt',
          { hour: d.getHours(), minute: d.getMinutes() },
          { ampm: true }
        )
      );
    })
    .on('click', '.datetimepicker', function () {
      $(this)
        .datetimepicker({
          showOn: 'focus',
          dateFormat: window.pmatrix.ui.dateFormat,
          ampm: true,
        })
        .focus();
    })
    .on('format', '.datetimepicker', function () {
      var d = $(this).datetimepicker('getDate');
      if (typeof d == 'undefined') d = new Date();
      $(this).val(
        $.datepicker.formatDate(window.pmatrix.ui.dateFormat, d) +
          ' ' +
          $.datepicker.formatTime(
            'hh:mm tt',
            { hour: d.getHours(), minute: d.getMinutes() },
            { ampm: true }
          )
      );
    });

  $(document).ajaxSuccess(function () {
    $('.drop_down select').each(function () {
      $(this).siblings('.bg_tile').html($(this).find('option:selected').html());
    });
  });

  var received_401 = false;

  $(document).ajaxError(function (xhr, status, err) {
    if (status.status == 401 && received_401 == false) {
      received_401 = true;
      window.pmatrix.ui.FlashPopup.create({
        message:
          'The operation could not be completed because your session has expired.',
        fade_time: 5000,
        callback: function () {
          var error_hash;
          try {
            error_hash = {
              error: JSON.parse(status.responseText).error,
              email: JSON.parse(status.responseText).email,
            };
          } catch (e) {
            error_hash = { error: status.responseText };
          }
          $.ajax({
            url: '/ajax_unauthorized',
            data: error_hash,
            success: function () {
              received_401 = false;
              window.location.href = window.RAILS_CONSTANTS['login_path'];
            },
          });
        },
      });
    } else if (status.status == 404) {
      window.pmatrix.ui.FlashPopup.create({
        message:
          'The specified record was not found. Please refresh the page and try again. If this problem persists, please contact Property Matrix support.',
        fade_time: 10000,
        callback: function () {},
      });
    } else if (status.status == 500) {
      window.server_error = true;
      /* Do not display this until we have moved to a dedicated database host
      pmatrix.ui.FlashPopup.create({
        message: "An unexpected error has occurred. An error report has been created and our developers are looking into it. If this problem persists, please contact Property Matrix support.",
        fade_time: 10000,
        callback: function() {}
      });
      */
    } else if (status.status == 503 && !error_handled_locally) {
      errorAlert(
        'Property Matrix is currently updating and your action was not completed. Please try again in 1 minute.'
      );
    } else if (
      status.responseText !== undefined &&
      status.responseText.indexOf('413 Request Entity Too Large') > -1
    ) {
      errorAlert(
        'The file you have selected to upload is too large. Please select a smaller file.'
      );
    }

    error_handled_locally = false;
  });

  $(document).on('click', '.curved_tabbed_header div.curved_tab', function () {
    $(this).siblings('div.curved_tab.selected').removeClass('selected');
    $(this).addClass('selected');
    selected = $(this).attr('id');
    my_tabs = $(this)
      .closest('.curved_tabbed_header')
      .next('.curved_tab_inset')
      .children('div.inset_table')
      .children('div.inset_pane, div.inset_table')
      .children('div.tab_pane')
      .hide();
    window.reinit_scroll_panes(
      my_tabs.filter('#' + selected + '_content').show()
    );
  });

  var repositionLightboxes_Timer;

  function repositionLightboxes() {
    $('body > .popup_window').each(function () {
      var $lightbox = $(this);
      $lightbox.offset({
        left: Math.max(($(window).width() - $lightbox.width()) / 2, -30),
        top: Math.max(
          (Math.min($(window).height(), 1000) - $lightbox.height()) / 2 +
            $(document).scrollTop(),
          $(document).scrollTop() - 30
        ),
      });
    });
  }

  $(window).on('resize', function () {
    clearTimeout(repositionLightboxes_Timer);
    repositionLightboxes_Timer = setTimeout(repositionLightboxes, 500);
  });

  $(document).on('change', 'select[name$=\\[country\\]]', function () {
    var $state_select = $(this).closest('tr').find('select[name$=\\[state\\]]');
    $state_select.empty();
    $state_select.append(
      $('#hidden_states_list')
        .find("optgroup[label='" + $(this).val() + "']")
        .html()
    );
    $state_select.change();

    //update address titles
    if ($(this).val() == 'Canada') {
      $state_select.closest('.field').find('label').html('Province');
      $state_select
        .closest('table')
        .find('.zipcode')
        .closest('.field')
        .find('label')
        .html('Postal Code');
    } else {
      $state_select.closest('.field').find('label').html('State');
      $state_select
        .closest('table')
        .find('.zipcode')
        .closest('.field')
        .find('label')
        .html('Zipcode');
    }
  });

  // Enable backward-compatible form placeholders
  $('input, textarea').placeholder();

  setTimeout(window.initCheckNotifications, checkSessionTimeoutInterval);

  // TODO: this causes the search menu to be unusable
  // Slide toggle animation for Chosen.js dropdown menus

  $(document).on('click', '.chosen-single', function (e) {
    var $chosenDrop = $('.chosen-drop');
    var $thisChosenDrop = $(this).next('.chosen-drop');

    // Slide up all other dropdowns
    $chosenDrop.slideUp();

    // If dropdown is visble, slide this up when clicked
    if ($thisChosenDrop.is(':visible')) {
      $thisChosenDrop.slideUp();
    }

    // If dropdown is hidden, slide this down when clicked
    if ($thisChosenDrop.is(':hidden')) {
      $thisChosenDrop.slideDown();
    }
  });

  $(document).on('click', '.active-result', function () {
    $(this).closest('.chosen-drop').slideUp();
  });
};

$(document).ready(function () {
  applicationInit();

  // this function only works on development
  // in order to use this function, include the script tag:
  //   <script type="text/javascript" src="https://jstest.authorize.net/v1/Accept.js" charset="utf-8"></script>
  // and also set the clientKey and apiLoginID, found in development.rb
  window.get_test_tokens = function () {
    var secureData = {},
      authData = {},
      cardData = {};

    cardData.cardNumber = '4111111111111111';
    cardData.month = '01';
    cardData.year = '2019';
    secureData.cardData = cardData;

    authData.clientKey = '';
    authData.apiLoginID = '';
    secureData.authData = authData;

    Accept.dispatchData(secureData, 'testHandler');
  };

  window.testHandler = function (response) {
    if (response.messages.resultCode === 'Error') {
      error_message = '';
      for (var i = 0; i < response.messages.message.length; i++) {
        if (i > 0) error_message += '; ';
        error_message += response.messages.message[i].text;
      }
      console.log(error_message);
    } else console.log(response.opaqueData);
  };
});

window.getHighestZIndex = function () {
  var index_highest = 0;
  var last_lightbox = null;
  if (window.current_lightbox != null && window.current_lightboxes.length > 0) {
    var last_lightbox =
      window.current_lightboxes[window.current_lightboxes.length - 1];
  }
  if (last_lightbox && $('#' + last_lightbox.id + '-div').length != 0) {
    index_highest = parseInt($('#' + last_lightbox.id + '-div').css('z-index'));
    if (isNaN(index_highest)) {
      index_highest = 1000; // error handling for if z_index is auto
    }
  } else {
    if ($('#frontend_loading_spinner').length > 0)
      // Front end lightboxes are not accounted for in current_lightboxes
      // Z-index of the frontend lightboxes are set to 9990
      index_highest = 10000;
    else index_highest = 1000; //to put dialog boxes & flash popups on same level as lightboxes
  }
  return index_highest;
};

$(document).on('click', '.styled_lightbox_close', function () {
  window.current_lightbox.close();
});
